import React from 'react';
import { DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface AppDialogTitleProps {
  children: React.ReactNode;
  onClose?: () => void;
  /** Put on the title text so a dialog's aria-labelledby names it without the close button. */
  id?: string;
}

export function AppDialogTitle({ children, onClose, id }: AppDialogTitleProps) {
  return (
    <DialogTitle
      sx={{
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        py: 1.5,
        px: 2.5,
      }}
    >
      <Typography id={id} variant="h6" component="span" sx={{ fontWeight: 600, fontSize: '1rem' }}>
        {children}
      </Typography>
      <IconButton
        onClick={onClose}
        aria-label="Close dialog"
        size="small"
        sx={{ color: 'primary.contrastText', ml: 1, '&:hover': { bgcolor: 'rgba(255,255,255,0.15)' } }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </DialogTitle>
  );
}
